export enum PaymentLinkType {
    OPEN = "open",
    CLOSED = "closed",
}

export enum PaymentLinkStatus {
    ACTIVE = "active",
    USED = "used",
    EXPIRED = "expired",
}

export type PaymentLinkBillType = "ci" | "pr100";

export interface IPaymentLinkInvoice {
    invoice_id: string;
    provider_name: string;
    date_of_service: string;
    appointment_type: string | null;
    payment_type: PaymentLinkBillType;
    amount: number;
}

export interface IPaymentLinkDetails {
    client_name: string;
    invoices: IPaymentLinkInvoice[];
    total_amount: number;
    link_status: PaymentLinkStatus;
    code_required?: boolean;
    coded?: boolean;
    practice_id?: string;
}

export interface IVerifyPaymentLinkCodePayload {
    ref: string;
    code: string;
}

export interface IVerifyPaymentLinkCodeResponse {
    verified: boolean;
}

export interface IGetPaymentLinkDetailsPayload {
    ref: string;
    code?: string;
}

export interface IProcessPaymentLinkPaymentPayload {
    ref: string;
    tokenized_payment: {
        opaque_data: {
            dataDescriptor: string;
            dataValue: string;
        };
        billing_info: {
            first_name: string;
            last_name: string;
            billing_address: string;
            state: string;
            zip_code: string;
            country: string;
        };
    };
    code?: string;
}
